import { uuid } from '../../utils'
import { ACCESS_TYPE } from './enums'
import { ClientData, SourceData, Subscription } from './types'


export class TelemetrySession<T> {
  #playbackId: string
  #userId: string
  #subscription: Subscription
  #client: ClientData
  #source?: SourceData
  #content: T
  #accessType: ACCESS_TYPE

  get id() {
    return this.#playbackId
  }

  get subscription() {
    return this.#subscription
  }

  set subscription(value: Subscription) {
    this.#subscription = value
  }

  get accessType() {
    return this.#accessType
  }

  set accessType(value: ACCESS_TYPE) {
    this.#accessType = value
  }

  get data() {
    return {
      user: {
        id: this.#userId,
        subscription: this.#subscription
      },
      client: this.#client,
      content: this.#content,
      accessType: this.accessType,
      source: this.#source,
      playbackId: this.#playbackId
    }
  }

  set userId(value: string) {
    this.#userId = value
  }

  set source(value: SourceData) {
    this.#source = value
  }

  set client(value: ClientData) {
    this.#client = value
  }

  set content(value: T) {
    this.#content = value
  }

  set playbackId(value: string) {
    this.#playbackId = value
  }

  constructor(userId: string, subscription: Subscription, client: ClientData, content: T, accessType: ACCESS_TYPE) {
    this.#playbackId = uuid()
    this.#userId = userId
    this.#subscription = subscription
    this.#client = client
    this.#content = content
    this.#accessType = accessType
  }
}
